import EndScreenComponent from './EndScreenComponent';

export default EndScreenComponent;
